import { Router } from './screen/router'
import { OpizeWrapper } from 'opize-design-system'

function App() {
  return (
    <OpizeWrapper>
      <Router />
    </OpizeWrapper>
  );
}

export default App;
